import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'medical/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('medical/', '')
      .toLowerCase();
  }
}
